import Picker from 'vanilla-picker'

const setExample = (inputID, color) => {
  const elementForBackgroundColor = document.querySelector(
    `[data-behaviour="color-pickers-preview"][data-href-background-color="#${inputID}"]`
  )
  const elementForTextcolor = document.querySelector(
    `[data-behaviour="color-pickers-preview"][data-href-text-color="#${inputID}"]`
  )

  if (elementForBackgroundColor) {
    elementForBackgroundColor.style.backgroundColor = color
  }
  if (elementForTextcolor) {
    elementForTextcolor.style.color = color
  }
}

onDomLoad(($dom) => {
  $dom.find('[data-behaviour="color-picker"]').each((_index, element) => {
    const input = element.querySelector('input')
    const button = element.querySelector('button')

    // Set the button background color as the selected color
    button.style.backgroundColor = `#${input.value}`

    const colorPicker = new Picker({
      parent: element,
      alpha: false,
      editorFormat: 'hex',
      color: `#${input.value}ff`,
    })

    colorPicker.onChange = (color) => {
      button.style.backgroundColor = color.hex.slice(0, -2)
      input.value = color.hex.slice(1, -2)
      setExample(input.id, color.hex.slice(0, -2))
    }
  })
})
